import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import type { GalleryProject } from '../types/content';
import { BeforeAfterSlider } from './BeforeAfterSlider';
import { ui } from '../data/ui';
interface GalleryGridProps {
  projects: GalleryProject[];
  columns?: string;
}
export function GalleryGrid({
  projects,
  columns = 'sm:grid-cols-2 xl:grid-cols-3'
}: GalleryGridProps) {
  const {
    t
  } = useLanguage();
  return <ul className={`grid gap-6 ${columns}`} data-id="element-118" data-mp="3epigq6jrrf95">
      {projects.map(project => <li key={project.id} className="flex flex-col overflow-hidden rounded-xl border border-navy/10 bg-white shadow-card" data-id="element-119" data-mp="3aof5xygkw9es">
          {project.before ? <BeforeAfterSlider before={project.before} after={project.after} caption={t(project.caption)} data-id="element-120" data-mp="3jntpedybvjps" /> : <div className="relative aspect-[4/3] overflow-hidden bg-navy" data-id="element-121" data-mp="2qzo49q3d3spf">
              <img src={project.after} alt={t(project.caption)} className="h-full w-full object-cover" loading="lazy" data-id="element-122" data-mp="2qxk3hh0rf9td" />
            </div>}
          <div className="flex flex-1 flex-col p-5" data-id="element-123" data-mp="3dvgxt6bor5gj">
            <p className="text-xs font-semibold uppercase tracking-[0.1em] text-gold-dark" data-id="element-124" data-mp="3dwsaxwr0tpkb">
              {t(project.category)}
            </p>
            <h3 className="mt-2 font-display text-lg leading-snug text-navy" data-id="element-125" data-mp="2l7uve1e726v9">
              {t(project.caption)}
            </h3>
            {project.before ? <p className="mt-auto pt-4 text-sm text-ink/60" data-id="element-126" data-mp="2q8imen2fanph">{t(ui.dragToCompare)}</p> : null}
          </div>
        </li>)}
    </ul>;
}